import { ThemeTypes } from 'components';
import theme from './theme';

const DEFAULT_SCROLLBAR_WIDTH = 4;
const DEFAULT_SCROLLBAR_RADIUS = 3;

const scrollbar = (props?: ThemeTypes.ScrollbarProps): ThemeTypes.Scrollbar => {
    const {
        width = DEFAULT_SCROLLBAR_WIDTH,
        radius = DEFAULT_SCROLLBAR_RADIUS,
        trackColor = 'transparent',
        color = theme.palette.primary.main
    } = props || {};

    return {
        '@supports (scrollbar-color: auto)': {
            scrollbarWidth: 'thin',
            scrollbarColor: `${color} ${trackColor}`
        },
        '@supports selector(::-webkit-scrollbar)': {
            '&::-webkit-scrollbar': {
                width: `${width}px`,
                height: `${width}px`
            },
            '&::-webkit-scrollbar-track': {
                background: trackColor
            },
            '&::-webkit-scrollbar-thumb': {
                background: color,
                borderRadius: `${radius}px`,
                '&:hover': {
                    background: `${color}.dark`
                }
            },
            '&::-webkit-scrollbar-corner': {
                background: trackColor
            }
        }
    };
};

export default scrollbar;
